export const messages = {
  popover: {
    'en-US': {
      error: 'Something went wrong',
      retry: 'Try again',
      noResultsTitle: 'No options match your search',
      noResultsSubtitle: 'Try using different terms',
      searchPlaceholder: 'Start typing to search',
    },
    'es-AR': {
      error: 'Algo salió mal',
      retry: 'Intentar otra vez',
      noResultsTitle: 'Ninguna opción coincide con su búsqueda',
      noResultsSubtitle: 'Intenta usar términos diferentes',
      searchPlaceholder: 'Empieza a escribir para buscar',
    },
    'fr-FR': {
      error: "Quelque chose s'est mal passé",
      retry: 'Réessayer',
      noResultsTitle: 'Aucune option ne correspond à votre recherche',
      noResultsSubtitle: "Essayez d'utiliser des termes différents",
      searchPlaceholder: 'Commencez à taper pour rechercher',
    },
    'pt-BR': {
      error: 'Algo deu errado',
      retry: 'Tente novamente',
      noResultsTitle: 'Nenhuma opção corresponde à sua pesquisa',
      noResultsSubtitle: 'Tente usar termos diferentes',
      searchPlaceholder: 'Comece a digitar para pesquisar',
    },
    'ja-JP': {
      error: '何かがうまくいかなかった',
      retry: '再試行',
      noResultsTitle: '検索に一致するオプションはありません',
      noResultsSubtitle: '別の用語を使用してみてください',
      searchPlaceholder: '検索するために入力を開始します',
    },
    'ko-KR': {
      error: '문제가 발생했습니다.',
      retry: '다시 시도하십시오',
      noResultsTitle: '검색어와 일치하는 옵션이 없습니다',
      noResultsSubtitle: '다른 용어를 사용해 보세요',
      searchPlaceholder: '검색을 위해 입력 시작',
    },
    'it-IT': {
      error: 'Qualcosa è andato storto',
      retry: 'Riprova',
      noResultsTitle: 'Nessuna opzione corrisponde alla tua ricerca',
      noResultsSubtitle: 'Prova a usare termini diversi',
      searchPlaceholder: 'Inizia a digitare per cercare',
    },
    'nl-NL': {
      error: 'Er is iets fout gegaan',
      retry: 'Probeer het opnieuw',
      noResultsTitle:
        'Er zijn geen opties die overeenkomen met uw zoekopdracht',
      noResultsSubtitle: 'Probeer andere termen te gebruiken',
      searchPlaceholder: 'Begin met typen om te zoeken',
    },
    'ro-RO': {
      error: 'Ceva n-a mers bine',
      retry: 'Încearcă din nou',
      noResultsTitle: 'Nicio opțiune nu se potrivește căutării dvs',
      noResultsSubtitle: 'Încercați să utilizați termeni diferiți',
      searchPlaceholder: 'Începeți să tastați pentru a căuta',
    },
    'bg-BG': {
      error: 'Нещо се обърка',
      retry: 'Опитай пак',
      noResultsTitle: 'Няма опции, отговарящи на вашето търсене',
      noResultsSubtitle: 'Опитайте да използвате различни термини',
      searchPlaceholder: 'Започнете да пишете, за да търсите',
    },
  },
  tag: {
    'en-US': {
      removeLabel: 'Remove item',
    },
    'es-AR': {
      removeLabel: 'Remover el artículo',
    },
    'fr-FR': {
      removeLabel: "Retirer l'objet",
    },
    'pt-BR': {
      removeLabel: 'Remover item',
    },
    'ja-JP': {
      removeLabel: 'アイテムを削除',
    },
    'ko-KR': {
      removeLabel: '항목 제거',
    },
    'it-IT': {
      removeLabel: 'Rimuovi oggetto',
    },
    'nl-NL': {
      removeLabel: 'Verwijder voorwerp',
    },
    'ro-RO': {
      removeLabel: 'Eliminați elementul',
    },
    'bg-BG': {
      removeLabel: 'Премахни артикул',
    },
  },
  fieldMultiple: {
    'en-US': {
      placeholder: 'Keep typing...',
    },
    'es-AR': {
      placeholder: 'Sigue escribiendo...',
    },
    'fr-FR': {
      placeholder: 'Continuez à taper...',
    },
    'pt-BR': {
      placeholder: 'Continue digitando...',
    },
    'ja-JP': {
      placeholder: '入力を続けてください...',
    },
    'ko-KR': {
      placeholder: '계속 타자...',
    },
    'it-IT': {
      placeholder: 'Continua a scrivere...',
    },
    'nl-NL': {
      placeholder: 'Blijf typen...',
    },
    'ro-RO': {
      placeholder: 'Continuă să tastezi...',
    },
    'bg-BG': {
      placeholder: 'Продължавайте да пишете...',
    },
  },
}
